import config from 'config';

export const isApiUrl = (baseUrl?: string) =>
  baseUrl === config.API_BASE && !baseUrl.includes('oauth');
